<template>
  <div class="btnList">
    <img
      class="home_sevstatu"
      src="@/assets/adule_img/btnList/home_sevstatu.png"
      alt=""
    />
    <img
      @click="gotoMy"
      class="my_icon"
      src="@/assets/adule_img/btnList/myIcon.png"
      alt=""
    />
    <div class="card_block">
      <img class="seat" src="@/assets/adule_img/btnList/seat.png" alt="" />
      <div class="cnt">
        <div
          class="cnt_block"
          :class="activeType == 2 ? 'activeClass' : ''"
          @click="handleTab('2')"
        >
          <!-- <div class="cnt_title">按摩+充电</div> -->
          <div class="cnt_title">全量套餐</div>
          <img
            class="icon2"
            src="@//assets/adule_img/btnList/setmenu.png"
            alt=""
          />
        </div>
        <div
          class="cnt_block"
          :class="activeType == 1 ? 'activeClass' : ''"
          @click="handleTab('1')"
        >
          <div class="cnt_title" style="margin-left: -38px">手机充电</div>
          <img
            class="icon1"
            src="@//assets/adule_img/btnList/charge.png"
            alt=""
          />
        </div>
      </div>
      <div class="btn_block" @click="gotoOper">
        <div class="btn">确定</div>
      </div>
    </div>
    <div class="tel">客服电话：400-8280-681</div>
    <!-- <div class="title">请选择模式</div> -->
    <!-- 请选择模式 1按摩·2加热·3输液 -->
    <!-- <div class="priceList">
      <div class="line" @click="handleClick('1')">
        <div class="numInput">充电</div>
      </div>
      <div class="line" @click="handleClick('2')">
        <div class="numInput">套餐</div>
      </div>
    </div> -->
    <!-- 按钮 -->
    <!-- <div
      style="
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        width: 100%;
        margin-top: 20px;
      "
    >
      <div class="btn" @click="gotoList">确 定</div>
    </div> -->
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "WorkspaceJsonBtnList",

  data() {
    return {
      activeType: "2", // 当前激活的类型，默认为1（手机充电）
      price_type: "", // 价格类型
      js_code: "", // 从URL获取的jscode
      open_id: "", // 用户的open_id
      qinghai: "",
    };
  },

  mounted() {
    // 获取js_code和openid
    this.getjsCode();
    this.getPriceList();
  },

  methods: {
    // 获取套餐价格接口------为了获取有些医院没有充电的模块，提示没有供电功能  1有充电 /  0没有充电
    async getPriceList() {
      try {
        const res = await axios.get(
          "https://htapi.zxznzy.com/project/get_money_list",
          {
            params: {
              equ_id: localStorage.getItem("text") || "861538074490688",
            },
          }
        );
        if (res.data.code === 200) {
          this.qinghai = res.data.pro_money_list[0].qinghai;
          // localStorage.setItem("is_running", res.data.is_running);
        }
      } catch (err) {
        console.error("获取价格列表失败:", err);
      }
    },
    // 选择操作类型
    handleTab(type) {
      this.activeType = type; // 设置当前激活的类型
    },
    // 选择完之后确定
    gotoOper() {
      // 跳转到操作页面   1有充电 /  0没有充电
      if (this.activeType == "1") {
        if (this.qinghai == 0) {
          this.$message.warning("当前医院没有充电功能，请选择套餐");
          return;
        } else {
          this.$router.push({
            path: "/charge", //跳到充电页面
          });
        }
      } else if (this.activeType == "2") {
        this.$router.push({
          path: "/wxcode", //跳到套餐价格页面页面，实际上是orderpay，这里是路由配置的
        });
      }
      // this.gotoList(); // 调用跳转方法
    },
    // 获取用户js_code
    async getjsCode() {
      // 尝试从URL参数获取code
      this.js_code = this.getcode("code");
      localStorage.setItem("js_code", this.js_code);
      // 向后端请求openid
      try {
        await this.fetchOpenId();
      } catch (err) {
        this.error = "获取OpenID失败: " + err.message;
      } finally {
        console.log("获取js_code完成");
      }
    },
    // 获取URL参数
    getcode(name) {
      const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`, "i");
      const r = window.location.search.substr(1).match(reg);
      if (r != null) return decodeURIComponent(r[2]);
      return null;
    },
    // 获取openid
    fetchOpenId() {
      try {
        axios({
          method: "get",
          url: "https://htapi.zxznzy.com/project/get_code",
          params: {
            code: localStorage.getItem("js_code"),
          },
        })
          .then((response) => {
            if (response.data.openid) {
              this.open_id = response.data.openid;
              localStorage.setItem("open_id", this.open_id); // 存储open_id到本地存储
            }
          })
          .catch((err) => {
            console.log("222", err);
          });
      } catch (error) {
        console.log("error", error);
      }
    },
    // 去我的页面
    gotoMy() {
      this.$router.push({
        path: "/my",
      });
    },
    //   handleClick(type) {
    //   this.price_type = type; // 设置价格类型
    // },
    // gotoList() {
    //   // 跳转到订单列表
    //   if (this.price_type) {
    //     this.$router.push({
    //       path: "/wxcode",
    //       query: { price_type: this.price_type },
    //     });
    //   } else {
    //     this.$message.warning("请选择模式");
    //   }
    // },
  },
};
</script>

<style lang="scss" scoped>
.btnList {
  background: linear-gradient(to bottom, #c1f7f5, #fff);
  background-size: cover;
  width: 100%;
  height: 100vh;
  position: relative;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 30px 0;
  box-sizing: border-box;
  .home_sevstatu {
    width: 96%;
    height: 24vh;
    margin-top: 7px;
  }
  .my_icon {
    width: 2.2rem;
    height: 2.2rem;
    position: absolute;
    right: 10px;
    top: 10px;
  }
  .card_block {
    width: 100%;
    height: 58vh;
    border-radius: 1rem;
    background: #fff;
    position: relative;
    .seat {
      position: absolute;
      width: 54vw;
      height: 38vh;
      top: -8rem;
      left: 50%;
      transform: translateX(-58%);
    }
    .cnt {
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      margin-top: 24vh;
      .cnt_block {
        width: 42%;
        background: #d1d1d1;
        height: 22vh;
        border-radius: 10px;
        // padding: 15px 0 0 11px;
        text-align: center;
        box-sizing: border-box;
        .cnt_title {
          font-family: FZLanTingHeiS-EB-GB;
          font-weight: 400;
          font-size: 15px;
          color: #ffffff;
          margin-top: 1rem;
        }
        .icon1 {
          width: 6.2rem;
          height: 3.3rem;
          margin-top: 2.7rem;
        }
        .icon2 {
          width: 4.5rem;
          height: 3.5rem;
          margin-top: 2.7rem;
        }
      }
      .cnt_block.activeClass {
        background: linear-gradient(to bottom, #34c6c4, #a9e3e3);
      }
    }
    .btn_block {
      display: flex;
      justify-content: center;
      .btn {
        width: 17rem;
        height: 2.3rem;
        line-height: 2.3rem;
        color: #fff;
        background: linear-gradient(to bottom, #34c6c4, #a9e3e3);
        text-align: center;
        border-radius: 20px;
        margin-top: 2rem;
        font-family: FZLanTingHeiS-EB-GB;
        font-weight: 400;
        font-size: 19px;
        color: #ffffff;
      }
    }
  }
  .tel {
    font-family: FZLanTingHeiS-R-GB;
    font-weight: 400;
    font-size: 13px;
    color: #8b8b8b;
    opacity: 0.81;
    margin-top: 25px;
  }
}
</style>
